// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"62":"87d91422","361":"a23f5b9d","485":"fea826c6","558":"5a3cd438","600":"25669637","673":"41951524","761":"5e6e44d0","833":"70317080"}[chunkId] + ".js";
};